import React, { useState } from "react";
import { API_BASE_URL } from "../config";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Swal from "sweetalert2";
import axios from "axios";
import "./PaymentMethod.css"; // Ensure this CSS file is updated
import { RxCross2 } from "react-icons/rx";
import { Button } from "react-bootstrap";
import Analytics from "../components/GoogleAnalytics";
const PaymentMethod = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedPackage = location.state?.selectedPackage;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("stripe"); // default to stripe
  const [easypaisaMsisdn, setEasypaisaMsisdn] = useState("");
  const [easypaisaEmail, setEasypaisaEmail] = useState("");
  const [showEasypaisaInstructions, setShowEasypaisaInstructions] =
    useState(false);
  const handleConfirmPayment = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!selectedPackage) return;

    setLoading(true);
    setError(null);

    const user = JSON.parse(sessionStorage.getItem("user")) || {};
    // alert("User data: " + JSON.stringify(user));
    if (!user?.payLoad?.access_token) {
      Swal.fire({
        icon: "info",
        title: "Login",
        text: "Please login first",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      }).then(() => {
        navigate(`/login/payment-method`);
      });
      setLoading(false);
      return;
    } else {
      const profileId = user?.payLoad.user.Id;
      const packageId = selectedPackage.id;
      if (paymentMethod === "stripe") {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/stripe/payment`,
            {
              params: {
                profile_id: profileId,
                package_id: packageId,
              },
            }
          );

          if (response.data.statusCode === 1) {
            const paymentUrl = response.data.payLoad.url;
            if (paymentUrl) {
              window.location.href = paymentUrl;
            } else {
              setError("Payment URL not found. Please try again.");
            }
          } else {
            setError("Failed to initiate payment. Please try again.");
          }
        } catch (err) {
          console.error(err);
          setError("An error occurred while processing your payment.");
        } finally {
          setLoading(false);
        }
      } else if (paymentMethod === "debitcredit") {
        try {
          // Store packageId in sessionStorage for DebitSuccessFail
          sessionStorage.setItem("debit_package_id", packageId);
          // 1. Initiate payment
          const orderId = Math.floor(
            100000 + Math.random() * 900000
          ).toString();
          // let return_url =
          //   "http://localhost:3000/debit-payment-status";
          let return_url =
            "https://appointment.webdoc.com.pk/debit-payment-status";

          let amount = selectedPackage.discountedPrice;
          // Extract only the numeric part (e.g., "Rs. 999/- only" -> "999")
          const match = amount.match(/\d+/);
          amount = match ? match[0] : "";
          // amount = 10;
          const initiateRes = await axios.get(
            `${API_BASE_URL}/payment/initiate`,
            {
              params: {
                orderid: orderId,
                amount: amount,
                transaction_type: 2,
              },
            }
          );
          if (initiateRes.data.statusCode !== 1) {
            throw new Error("Failed to initiate Debit/Credit Card payment");
          }
          const { auth_token, order_id } = initiateRes.data.payLoad;
          // 2. SSO Redirect
          const ssoRes = await axios.get(
            `${API_BASE_URL}/payment/sso-redirect`,
            {
              params: {
                auth_token: auth_token,
                return_url: return_url,
                transaction_type_id: "2",
                transaction_reference_number: order_id,
                transaction_amount: amount,
              },
            }
          );
          if (ssoRes.data.statusCode === 1 && ssoRes.data.payLoad) {
            window.location.href = ssoRes.data.payLoad;
          } else {
            setError("Something went wrong. Please try again later.");
          }
        } catch (err) {
          console.error(err);
          setError("Something went wrong. Please try again later.");
        } finally {
          setLoading(false);
        }
      } else if (paymentMethod === "easypaisa") {
        // EasyPaisa payment logic

        try {
          if (!easypaisaMsisdn || !easypaisaEmail) {
            setError(
              "Please enter your mobile number and email for EasyPaisa payment."
            );
            setLoading(false);
            return;
          }
          setShowEasypaisaInstructions(true);

          let amount = selectedPackage.discountedPrice;
          const match = amount.match(/\d+/);
          amount = match ? match[0] : "";
          // Prepare payload
          const payload = {
            store_name: "StudentFeeCollectionStore",
            msisdn: easypaisaMsisdn,
            email: easypaisaEmail,
            // amount: "1",
            amount: amount,
          };
          // Use user's access_token for Authorization header
          const token = user.payLoad.access_token;
          const response = await axios.post(
            "https://paymentgtw.webddocsystems.com/public/api/v1/service/direct-payment",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Basic V2ViRG9jRXNheVBhaXNhU3RvcmU6V2ViRG9jQDMyMQ==",
              },
            }
          );
          // Wait for up to 1 minute for approval
          let result = response.data;
          if (result.statusCode === "0000") {
            let approved = false;
            setShowEasypaisaInstructions(false);

            Swal.fire({
              icon: "success",
              title: "Payment Successful",
              text: "Your EasyPaisa payment was successful.",
              confirmButtonText: "OK",
            }).then(() => {
              navigate(
                "/payment-success?package_id=" +
                  packageId +
                  "&eaypaisapayment=done"
              );
            });
            if (approved) {
              Swal.fire({
                icon: "success",
                title: "Payment Successful",
                text: "Your EasyPaisa payment was successful.",
                confirmButtonText: "OK",
              }).then(() => {
                navigate(
                  "/payment-success?package_id=" +
                    packageId +
                    "&eaypaisapayment=done"
                );
              });
            } else {
              setError(
                "EasyPaisa payment not approved. Please try again or use another method."
              );
            }
          }
        } catch (err) {
          console.error(err);
          setError("EasyPaisa payment failed. Please try again later.");
        } finally {
          setLoading(false);
        }
      }
    }
  };
  return (
    <>
      <Analytics />
      <Navbar />
      <div className="container py-5">
        <div className="row justify-content-center align-items-start g-4">
          {/* Left: Package Card */}
          <div className="col-lg-5 col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="card-title text-primary fw-bold mb-3">
                  Your Selection
                </h5>
                <h6 className="card-subtitle mb-2 text-dark fw-semibold">
                  {selectedPackage?.title}
                </h6>
                <ul className="list-group list-group-flush mb-2">
                  <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                    <span className="text-muted">Original Price:</span>
                    <span className="text-decoration-line-through text-secondary">
                      {selectedPackage?.originalPrice}
                    </span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                    <span className="text-muted">Discounted Price:</span>
                    <span className="fw-bold text-success">
                      {selectedPackage?.discountedPrice}
                    </span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                    <span className="text-muted">Discount:</span>
                    <span className="fw-bold text-danger">
                      {selectedPackage?.discount}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#e0f7fa",
                padding: "15px",
                borderRadius: "10px",
                marginTop: "20px",
              }}
            >
              <strong>Disclaimer</strong>

              <p style={{ marginBottom: 0, fontSize: "12px" }}>
                All doctor consultations and appointments conducted through the
                WEBDOC platform are the sole responsibility of the respective
                doctors. WEBDOC serves only as a facilitating platform and does
                not assume any liability for the medical advice, treatment, or
                outcomes resulting from these consultations.
              </p>
            </div>
          </div>

          {/* Right: Payment Methods */}
          <div className="col-lg-5 col-md-6 mb-4">
            <div className="card shadow border-0 h-100">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-4">
                  Select Payment Method
                </h5>
                {error && (
                  <div className="alert alert-danger py-2">{error}</div>
                )}
                <div className="mb-4">
                  <div
                    className={`form-check d-flex align-items-center mb-3 p-3 rounded ${
                      paymentMethod === "stripe"
                        ? "border border-primary bg-light"
                        : "border"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setPaymentMethod("stripe")}
                  >
                    <input
                      className="form-check-input me-3"
                      type="radio"
                      name="paymentMethod"
                      value="stripe"
                      checked={paymentMethod === "stripe"}
                      onChange={() => setPaymentMethod("stripe")}
                      style={{ accentColor: "#635bff" }}
                    />
                    <span className="fw-semibold fs-6 text-primary">
                      Stripe
                    </span>
                  </div>
                  {/* <div
                    className={`form-check d-flex align-items-center mb-3 p-3 rounded ${
                      paymentMethod === "debitcredit"
                        ? "border border-secondary bg-light"
                        : "border"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setPaymentMethod("debitcredit")}
                  >
                    <input
                      className="form-check-input me-3"
                      type="radio"
                      name="paymentMethod"
                      value="debitcredit"
                      checked={paymentMethod === "debitcredit"}
                      onChange={() => setPaymentMethod("debitcredit")}
                      style={{ accentColor: "#e30613" }}
                    />
                    <span className="fw-semibold fs-6 text-secondary">
                      Debit/Credit Card
                    </span>
                  </div> */}
                  <div
                    className={`form-check d-flex align-items-center mb-3 p-3 rounded ${
                      paymentMethod === "easypaisa"
                        ? "border border-success bg-light"
                        : "border"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentMethod("easypaisa");
                    }}
                  >
                    <input
                      className="form-check-input me-3"
                      type="radio"
                      name="paymentMethod"
                      value="easypaisa"
                      checked={paymentMethod === "easypaisa"}
                      onChange={() => setPaymentMethod("easypaisa")}
                      style={{ accentColor: "#1fa12e" }}
                    />
                    <span className="fw-semibold fs-6 text-success">
                      EasyPaisa
                    </span>
                  </div>
                  {paymentMethod === "easypaisa" && (
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="EasyPaisa Mobile Number (e.g. 03XXXXXXXXX)"
                        value={easypaisaMsisdn}
                        onChange={(e) => setEasypaisaMsisdn(e.target.value)}
                        maxLength={11}
                      />
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address"
                        value={easypaisaEmail}
                        onChange={(e) => setEasypaisaEmail(e.target.value)}
                      />
                    </div>
                  )}
                </div>

                <button
                  className="btn btn-success w-100 py-2 fw-bold fs-5"
                  onClick={handleConfirmPayment}
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : null}
                  {loading ? "Processing..." : "Proceed to Checkout"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showEasypaisaInstructions && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1040,
          }}
          onClick={() => setShowEasypaisaInstructions(false)} // Close on outside click
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header justify-content-between">
                <h5 className="modal-title">EasyPaisa Payment Instructions</h5>
              </div>
              <div className="modal-body">
                <p>To complete your payment via EasyPaisa:</p>
                <ol>
                  <li>Open your EasyPaisa app.</li>
                  <li>
                    Go to <strong>"My Account"</strong>.
                  </li>
                  <li>
                    Select <strong>"My Approvals"</strong>.
                  </li>
                  <li>
                    Find the pending payment and click <strong>"Accept"</strong>
                    .
                  </li>
                </ol>
              </div>
              {/* <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => setShowEasypaisaInstructions(false)}
                >
                  Got it!
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default PaymentMethod;
